import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo, waLink, EASE, fbLead } from "./primitives";

const NAV_ITEMS = [
  { label: "The House", id: "the-house" },
  { label: "Membership", id: "membership" },
  { label: "The Circle", id: "the-circle" },
  { label: "Journal", route: "/journal" },
  { label: "Connect", id: "contact" },
];

export default function Nav() {
  const [solid, setSolid] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  useEffect(() => {
    if (!onHome) { setSolid(true); return; }
    const onScroll = () => setSolid(window.scrollY > window.innerHeight * 0.72);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [onHome]);

  const handleAnchor = (id) => {
    if (onHome) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      navigate(`/#${id}`);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
    }
  };

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.4, ease: EASE }}
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        backgroundColor: solid ? "rgba(23,64,42,0.96)" : "rgba(23,64,42,0)",
        borderBottom: solid ? "1px solid rgba(120,132,107,0.25)" : "1px solid rgba(120,132,107,0)",
        transition: "background-color 380ms ease, border-color 380ms ease",
        backdropFilter: solid ? "blur(8px)" : "none",
      }}
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => (onHome ? handleAnchor("hero") : navigate("/"))}
          className="flex items-center gap-3"
          data-testid="nav-logo-btn"
        >
          <Logo size={46} />
          <span className="font-heading text-[1rem] tracking-[0.3em] uppercase font-normal hidden sm:block" style={{ color: "var(--ivory)" }}>
            Hitakari
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.label}
              onClick={() => (item.route ? navigate(item.route) : handleAnchor(item.id))}
              className="font-label text-[0.8rem] tracking-[0.18em] uppercase link-underline font-light"
              style={{ color: "var(--ivory)" }}
              data-testid={`nav-${item.route ? item.route.replace(/\//g, "") : item.id}`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => fbLead("whatsapp")}
          className="font-label text-[0.72rem] tracking-[0.2em] uppercase px-5 py-2.5 font-light"
          style={{ backgroundColor: "var(--ivory)", color: "var(--forest)", transition: "background-color 200ms ease, color 200ms ease" }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "var(--sage)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "var(--ivory)"; }}
          data-testid="nav-apply-btn"
        >
          Engage with Us
        </a>
      </div>
    </motion.header>
  );
}
